const Footer = () => {
    return (<div className="mt-16 mb-12 text-center">
        Poll v0.1 Made with ❤️ and React by <a href="mailto:ste.vaidis@gmail.com">ste.vaidis@gmail.com</a>
    </div>)
}

export default Footer
